export default class State {
  constructor() {
    this.adminVisitedPagesLoaded = false;
    this.adminVisitedPages = [];
    this.dashboardListPagesVisible = true;
  }
}
